import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Clock, X } from "lucide-react";

const PLAN_PRICE = { creator: 29, growth: 79, agency: 199, pro: 29 };

// Shows a dismissible countdown while the user is inside the paid $1 trial.
export default function TrialBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const days = user?.trial_days_left ?? 0;
  const key = `ags_trial_banner_dismissed_${days}`;
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(key) === "1"; } catch (e) { return false; }
  });

  if (!user?.in_paid_trial || dismissed) return null;
  const price = PLAN_PRICE[user?.plan] ?? 29;
  const dayLabel = days === 1 ? "1 day" : `${days} days`;

  const dismiss = () => {
    try { localStorage.setItem(key, "1"); } catch (e) {}
    setDismissed(true);
  };

  return (
    <div
      data-testid="trial-countdown-banner"
      className="mb-6 rounded-xl border border-primary/40 bg-gradient-to-r from-primary/12 to-accent/8 px-5 py-3 flex items-center justify-between gap-3 flex-wrap"
    >
      <p className="text-sm text-foreground/90 flex items-center gap-2">
        <Clock className="h-4 w-4 text-primary shrink-0" />
        <span>
          <span className="font-semibold text-primary" data-testid="trial-days-left">{dayLabel}</span>{" "}
          left in your $1 trial — then <span className="font-semibold">${price}/mo</span>. Cancel anytime.
        </span>
      </p>
      <div className="flex items-center gap-2 shrink-0">
        <Button
          size="sm"
          data-testid="trial-banner-manage"
          onClick={() => navigate("/billing")}
          className="bg-primary hover:bg-primary/90 text-white"
        >
          Manage plan
        </Button>
        <button
          data-testid="trial-banner-dismiss"
          onClick={dismiss}
          className="p-1.5 rounded-md text-muted-foreground hover:text-foreground hover:bg-secondary/60 transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
